/* eslint-disable complexity */
import React, { useEffect, useState } from 'react';
import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage, useIntl } from '@futrli/localisation';

import { Settings } from './settings/settings';
import { BulkUpdatePredictions } from './bulk-update/bulk-update-predictions';
import { BulkUpdateInvoicesBills } from './bulk-update/bulk-update-invoices-bills';

export enum ASSISTANT_TAB {
  PREDICTIONS = 'predictions',
  SETTINGS = 'settings',
  BULK_UPDATE_PREDICTIONS = 'bulk-update-predictions',
  BULK_UPDATE_INVOICES_BILLS = 'bulk-update-invoices-bills'
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
  initialActiveTab?: ASSISTANT_TAB;
}

const getHeaderTitle = (isBulkUpdate: boolean) => {
  return isBulkUpdate ? (
    <Typography variant="h2" fontWeight="700">
      <FormattedMessage id="common.bulk_update" defaultMessage="Bulk update" />
    </Typography>
  ) : (
    <Typography variant="h2" fontWeight="700">
      <FormattedMessage id="common.settings" defaultMessage="Settings" />
    </Typography>
  );
};

export const AssistantSidePanel = ({ isOpen, onClose, initialActiveTab }: Props) => {
  const intl = useIntl();

  const [activeTab, setActiveTab] = useState<ASSISTANT_TAB | undefined>(initialActiveTab || ASSISTANT_TAB.PREDICTIONS);

  useEffect(() => {
    setActiveTab(initialActiveTab);
  }, [initialActiveTab, isOpen]);

  const isBulkUpdate =
    activeTab === ASSISTANT_TAB.BULK_UPDATE_PREDICTIONS || activeTab === ASSISTANT_TAB.BULK_UPDATE_INVOICES_BILLS;

  return (
    <Sidebar
      open={isOpen}
      data-testid="snapshot-drawer"
      aria-label={intl.formatMessage({
        id: 'common.assistant_sidebar.aria_label',
        defaultMessage: 'Assistant sidebar'
      })}
      size="medium-large"
      enableBackgroundUI={activeTab === ASSISTANT_TAB.BULK_UPDATE_INVOICES_BILLS}
      header={getHeaderTitle(isBulkUpdate)}
    >
      <aside style={{ height: '100%' }}>
        <div style={{ height: '100%' }}>
          <>
            {activeTab === ASSISTANT_TAB.SETTINGS && <Settings onClose={onClose} />}
            {activeTab === ASSISTANT_TAB.BULK_UPDATE_PREDICTIONS && <BulkUpdatePredictions onClose={onClose} />}
            {activeTab === ASSISTANT_TAB.BULK_UPDATE_INVOICES_BILLS && <BulkUpdateInvoicesBills onClose={onClose} />}
          </>
        </div>
      </aside>
    </Sidebar>
  );
};
